import { render, staticRenderFns } from "./productsDetails.vue?vue&type=template&id=5b345395"
import script from "./productsDetails.vue?vue&type=script&lang=js"
export * from "./productsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports